module.exports = __webpack_public_path__ + "static/media/Webshopper-Custom-42.3f364dbc.3f364dbc.JPG";